import React from 'react'
import { Spacer, Text, View } from 'oio-react'
import { CommerceIcon, EmailNotificationsGlyphIcon24, HostingIcon, InfoIcon,
   IntegrationIcon, MetadataGlyph24Icon, PlanIcon, ReportGlyphIcon24 } from 'assets/icons'
import { settingsUrl, settingsSiteUrl } from 'config/constants/urls'
import ProtoColumnNavButton from 'src/components/Settings/ProtoColumnNavButton'
import ProtoHeadingBlock from 'src/components/Settings/ProtoHeadingBlock'
import ProtoReturnBar from 'src/components/Settings/ProtoReturnBar'

const SettingsSiteHome = () => (
   <View>
      <ProtoReturnBar
         display="block[a-b] none[c-f]"
         returnLinkName="Admin Workspace"
         returnLinkTo={settingsUrl}
      />
      <View>
         <View
            display="flex"
            justifyContent="center"
            width="100%">
            <View width="100%" maxWidth="90%[c] 480px[d]">
               <View
                  float="left"
                  display="flex"
                  padding="40px 20px[a-b] 40px 0px[c-d] 40px 20px[e-f]">
                  <ProtoHeadingBlock
                     colorMode="light"
                     title="Site Settings"
                     description="Manage the general settings for your Community site"
                  />
               </View>
               <View float="left" width="100%">
                  <View
                     backgroundColor="#fafafa"
                     padding="9px 0px[c-d]"
                     borderRadius="6px[c-d]"
                     borderTop="1px solid rgba(0,0,0,0.05)[a-b] 1px solid rgba(0,0,0,0.05)[e-f]"
                     borderBottom="1px solid rgba(0,0,0,0.05)[a-b] 1px solid rgba(0,0,0,0.05)[e-f]">
                     <ProtoColumnNavButton
                        borderStyle="none"
                        linkName="About this Site"
                        linkTo={`${settingsSiteUrl}/about`}
                        icon={(
                           <InfoIcon
                              className="icon"
                              width="14px"
                              height="14px"
                           />
                        )}
                     />
                     <ProtoColumnNavButton
                        linkName="Plan & Billing"
                        linkTo={`${settingsSiteUrl}/billing`}
                        icon={(
                           <PlanIcon
                              className="icon"
                              width="14px"
                              height="14px"
                           />
                        )}
                     />
                     <ProtoColumnNavButton
                        linkName="Domain & Hosting"
                        linkTo={`${settingsSiteUrl}/domain`}
                        icon={(
                           <HostingIcon
                              className="icon"
                              width="14px"
                              height="14px"
                           />
                        )}
                     />
                  </View>
                  <View width="100%" padding="15px 20px[a-b] 15px 0px[c-d] 15px 20px[e-f]">
                     <Spacer size="6" />
                     <Text size="1.5" weight="medium" color="#000">
                        Advanced Settings
                     </Text>
                  </View>
                  <View
                     backgroundColor="#fafafa"
                     padding="9px 0px[c-d]"
                     borderRadius="6px[c-d]"
                     borderTop="1px solid rgba(0,0,0,0.05)[a-b] 1px solid rgba(0,0,0,0.05)[e-f]"
                     borderBottom="1px solid rgba(0,0,0,0.05)[a-b] 1px solid rgba(0,0,0,0.05)[e-f]">
                     <ProtoColumnNavButton
                        borderStyle="none"
                        linkName="Integrations"
                        linkTo={`${settingsSiteUrl}/integrations`}
                        icon={(
                           <IntegrationIcon
                              className="icon"
                              width="16px"
                              height="16px"
                           />
                        )}
                     />
                     <ProtoColumnNavButton
                        linkName="Commerce & Discounts"
                        linkTo={`${settingsSiteUrl}/commerce`}
                        icon={(
                           <CommerceIcon
                              className="icon"
                              width="14px"
                              height="14px"
                           />
                        )}
                     />
                     <ProtoColumnNavButton
                        linkName="Email Notifications"
                        linkTo={`${settingsSiteUrl}/email-notifications`}
                        icon={(
                           <EmailNotificationsGlyphIcon24
                              className="icon"
                              width="16px"
                              height="16px"
                           />
                        )}
                     />
                     <ProtoColumnNavButton
                        linkName="Reports"
                        linkTo={`${settingsSiteUrl}/reports`}
                        icon={(
                           <ReportGlyphIcon24
                              className="icon"
                              width="14px"
                              height="14px"
                           />
                        )}
                     />
                     <ProtoColumnNavButton
                        linkName="Custom Metadata"
                        linkTo={`${settingsSiteUrl}/custom-metadata`}
                        icon={(
                           <MetadataGlyph24Icon
                              className="icon"
                              width="14px"
                              height="14px"
                           />
                        )}
                     />
                  </View>
               </View>
            </View>
         </View>
      </View>
   </View>
)

export default SettingsSiteHome
